import { allows, readChoice } from '@/services/cookieConsentCore.mjs';
import Cookies from "js-cookie";
import { decrypte, encrypte } from "./crypto";


const cookiesHandler = {
    hasAcceptedCookies() {
        return allows(readChoice(window.localStorage), 'analytics');
    },

    hasCookie(cookieName = ''){
        return ![null,undefined,''].includes(Cookies.get(cookieName)) ? true : false;
    },

    saveCookieAcecptance(){
        Cookies.set('accepted_cookies', '1');
    },

    removeCookieAcceptance(){
        Cookies.remove('accepted_cookies');
    },

    setEncryptedCookie(cookieName, value = ''){
        Cookies.set(cookieName, encrypte(value));
    },

    getEncryptedCookie(cookieName){
        return decrypte(Cookies.get(cookieName));
    }
}

export default cookiesHandler;
